"use client"
import { DropdownMenuItem } from "@/components/ui/dropdown-menu"
import {
	AlertDialog,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { Button } from "@/components/ui/button"
import { FC, useState } from "react"
import axios from "axios"
import { BASE_URL } from "@/config"
import { useRefresh } from "react-admin"
import { toast } from "sonner"
import { Trash2Icon } from "lucide-react"
import { useUserContext } from "@/context/UserContext"

interface Props {
	id: number;
	title: string;
	description?: string;
}
const Delete: FC<Props> = ({ id, title, description }) => {
	const { decodedToken } = useUserContext();
	const refresh = useRefresh();
	const [open, setOpen] = useState(false);


	const handleDeleteClick = (e: React.MouseEvent) => {
		e.preventDefault()
		e.stopPropagation()
		setOpen(true);
	}
	const confirmDelete = async () => {
		await axios.delete(`${BASE_URL}/tours/${id}`, {
			headers: {
				'Authorization': `Bearer ${window.localStorage.getItem("access_token")}`
			}
		}).then(() => {
			toast("This tour was deleted", {
				description: "This tour was deleted successfully"
			})
			refresh()
			setOpen(false);
		}).catch(err => {
			console.log(err)
		})
	}

	return (
		<>
			<DropdownMenuItem onClick={handleDeleteClick} disabled={decodedToken?.permissions.user_role !== 'owner'}>
				<Trash2Icon className="mr-2 h-4 w-4 text-destructive" />
				{title}
			</DropdownMenuItem>

			<AlertDialog open={open} onOpenChange={setOpen}>
				<AlertDialogContent>
					<AlertDialogHeader>
						<AlertDialogTitle>Are you sure you want to delete?</AlertDialogTitle>
						<AlertDialogDescription>
							{description || "This action can not be undone."}
						</AlertDialogDescription>
					</AlertDialogHeader>
					<AlertDialogFooter>
						<AlertDialogCancel onClick={(event) => {
							event.stopPropagation()
							setOpen(false);
						}}>Cancel</AlertDialogCancel>
						<Button variant="destructive" onClick={(event) => {
							event.stopPropagation();
							confirmDelete();
						}}>
							Delete
						</Button>
					</AlertDialogFooter>
				</AlertDialogContent>
			</AlertDialog>
		</>
	)
}
export default Delete